import { render } from "./LKFFooter.vue?vue&type=template&id=3929bd45&ts=true"
import script from "./LKFFooter.vue?vue&type=script&lang=ts"
export * from "./LKFFooter.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__